import { BookSessionAction } from "app/actions/scheduling/bookSession";

import { LessonSchedule } from 'app/models/EventModel';
import { ResourceLine } from 'app/utils/request/scheduling/facilityResources';
import { CoachProfileModel } from 'app/models/scheduling/CoachProfileModel';
import { FacilityModel } from 'app/models/scheduling/FacilityModel';
import { LessonRateModel } from 'app/models/scheduling/LessonRateModel';

export type BookSessionState = {
  lessonRateId: number;
  rate: number;
  facility: FacilityModel,
  coach: CoachProfileModel;
  date: string;
  timeZone: string;
  time: {
    startHour: number;
    endHour: number;
    timeZone: string;
  };
  public: boolean;
  isComplete: boolean;
  location: string;
  durationPricing: string;
  pricingValue: LessonRateModel;

  selectedSession?: LessonSchedule,
  duration: any;
  paymentMethod?: string;
  lessonRateTitle?: string;
  /**
   * External id of the family member this booking is for (CN-1323). Null/absent
   * means the booking is for the current user (self).
   */
  participantAthleteId?: string | null;
  /** The athlete label of the booked bay, one line a section, for the Session Booked popup. */
  resourceLines?: ResourceLine[];
};

const initialState: BookSessionState = {
  lessonRateId: null,
  rate: null,
  facility: null,
  coach: null,
  date: null,
  timeZone: null,
  time: null,
  public: false,
  isComplete: false,
  location: null,
  durationPricing: '',
  pricingValue: null,
  selectedSession: null,
  duration: {},
  participantAthleteId: null,
};


export default function bookSession(
  state = initialState,
  action: BookSessionAction
): BookSessionState {
  switch (action.type) {
    case "@bookSession.setIsComplete":
      return { ...state, isComplete: action.payload };
    case "@bookSession.init":
      return {
        ...state,
        ...action.payload,
      };
    case "@bookSession.set":
      return {
        ...state,
        ...action.payload,
        selectedSession: state.selectedSession,
      };
    case "@bookSession.setSelectedSession":
      return {
        ...state,
        selectedSession: action.payload,
      };
    case "@bookSession.reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}
